export    const downloadFileByUrl = async (fileUrl, fileName) => {
    if (!fileUrl) {
        console.error('Ссылка на файл отсутствует');
        return;
    }

    try {
        const response = await fetch(fileUrl);
        const blob = await response.blob();

        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url
        link.download = fileName || 'download_file';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url)
    } catch (error) {
        console.error('Ошибка при скачивании файла:', error);
    }
};